import Omit from 'omit.js';
import Base, { baseProps } from './Base';
const Paragraph = (props, { slots, attrs }) => {
    const paragraphProps = Object.assign(Object.assign(Object.assign({}, props), { component: 'div' }), attrs);
    return <Base {...paragraphProps} v-slots={slots}></Base>;
};
Paragraph.displayName = 'ATypographyParagraph';
Paragraph.inheritAttrs = false;
Paragraph.props = Omit(baseProps(), ['component']);
export default Paragraph;
